module.exports = __webpack_public_path__ + "img/phone.22329333.svg";